var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.label)?_c('label',{staticClass:"form-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e(),_c('sketch-picker',{attrs:{"disabled":_vm.disabled,"value":_vm.currentValue},on:{"input":_vm.updateValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }